// Traduzioni ES/ZH dell'interfaccia — generato da scripts/translate_ui.py (AI, da revisionare)
export const moreLangs = {
  "es": {
    "nav_stories": "Historias",
    "nav_shorts": "Video corto",
    "nav_author": "Autor",
    "nav_donate": "Apoya",
    "nav_contact": "Contacto",
    "nav_cta": "Lee la novela",
    "nav_login": "Acceder",
    "nav_logout": "Salir",
    "hero_kicker": "Una novela de Andrea Perocchi",
    "hero_sub": "una historia de amor",
    "hero_tag": "Noche, luces, ritmo. Una historia de amor entre la cabina y las palabras, entre Roma y Londres, al final del milenio.",
    "hero_cta1": "Empieza a leer",
    "hero_cta2": "Mira los shorts",
    "stat_stories": "Historias",
    "stat_chapters": "Capítulos",
    "stat_cities": "Roma ↔ Londres",
    "stat_pages": "Páginas",
    "marquee": "NOCHE · LUCES · RITMO · AMOR · MÚSICA · ROMA · LONDRES · GIULIA & ALEX · 26 CAPÍTULOS · DESTINO · ",
    "novel_kicker": "La novela",
    "novel_title": "El destino los empuja hacia un viaje en el que la felicidad se convierte en la verdadera conquista",
    "novel_text": "Alex convierte la cabina en un universo palpitante, Giulia persigue respuestas entre viajes, estudios y nuevas decisiones de vida. Su encuentro es casual, pero el destino los empuja hacia un viaje en el que la felicidad se convierte en la verdadera conquista. Entre fiestas, secretos y giros inesperados, Una vita da DJ cuenta cómo el amor y la música pueden cambiarlo todo.",
    "stories_kicker": "El libro en historias",
    "stories_title": "Veintiocho historias, dos voces, un solo ritmo",
    "stories_sub": "Cada capítulo es una historia para leer y para ver. Filtra por voz narradora y déjate arrastrar por la noche.",
    "stories_all": "Leer todas las historias",
    "filter_all": "Todas",
    "shorts_kicker": "Video short",
    "shorts_title": "Las historias cobran vida",
    "shorts_sub": "Cada historia tiene su short cinematográfico: tipografía cinética, ritmo y luces de cabina. Pulsa play.",
    "shorts_watch": "Ver el short",
    "support_kicker": "Apoya la historia",
    "support_title": "De la página al escenario",
    "support_sub": "Esta historia sueña con el teatro y el cine. Si te ha hecho latir el corazón, puedes apoyarla con una donación libre.",
    "support_cta": "Haz una donación",
    "author_kicker": "El autor",
    "author_title": "Detrás de la cabina, Andrea Perocchi",
    "author_cta": "Conoce al autor",
    "story_excerpt": "Fragmento del capítulo",
    "story_full": "Texto completo",
    "story_prev": "Historia anterior",
    "story_next": "Historia siguiente",
    "story_back": "Todas las historias",
    "story_continue": "La historia continúa en el libro",
    "gate_reg_title": "Sigue leyendo gratis",
    "gate_reg_sub": "Regístrate gratis para leer completos los capítulos 3, 4 y 5, directamente aquí.",
    "gate_reg_btn": "Regístrate gratis",
    "gate_pay_title": "La noche continúa",
    "gate_pay_sub": "Desbloquea el libro completo — los 26 capítulos y el epílogo, para siempre.",
    "gate_pay_btn": "Desbloquear por 10 €",
    "gate_donate_hint": "O bien apoya el proyecto con una donación libre",
    "player_short": "Video corto",
    "player_note": "Corto cinematográfico generado a partir del texto del capítulo",
    "player_audio": "Audio",
    "video_ai_btn": "Generar video con IA",
    "video_processing": "Generando video con IA…",
    "video_error": "La generación ha fallado",
    "chapter_word": "Cap.",
    "read": "Leer",
    "author_role": "DJ · Autor",
    "author_p1": "Andrea Perocchi (Roma, 1972) es consultor de marketing, telecomunicaciones e inteligencia artificial, además de editor, escritor y disc jockey. Hijo de un editor, fundó Radio Data Network —uno de los primeros proveedores de Internet en Italia— y dirigió revistas especializadas como Radiolink y Carte.",
    "author_p2": "En los años noventa vivió las cabinas de los clubes de Roma y de Italia bajo el seudónimo Double Andy DJ, conduciendo programas de radio en Spazio Radio. Apasionado de la vela, el cine y la pintura, en 2025 publicó Una vita da DJ y Vento a Prua, convirtiendo en novela las noches, la música y el mar de su vida.",
    "author_facts": "La cabina",
    "fact_1": "Double Andy DJ",
    "fact_2": "Radio y clubes de los años '90",
    "fact_3": "Vela y escritura",
    "author_opere": "Obras",
    "author_unpublished": "inédito",
    "buy_title": "Dónde encontrar el libro",
    "buy_note": "Una vita da DJ — una historia de amor · FM Editing, 2025",
    "buy_cta": "La página del autor",
    "auth_login_title": "Bienvenido de nuevo a la noche",
    "auth_register_title": "Entra en el club",
    "auth_name": "Nombre",
    "auth_email": "Correo electrónico",
    "auth_password": "Contraseña",
    "auth_login_btn": "Acceder",
    "auth_register_btn": "Regístrate gratis",
    "auth_forgot": "¿Olvidaste tu contraseña?",
    "auth_forgot_btn": "Enviar enlace de restablecimiento",
    "auth_forgot_sent": "Si el correo está registrado, recibirás el enlace en unos minutos.",
    "auth_or": "o",
    "auth_google": "Continuar con Google",
    "auth_have": "¿Ya tienes una cuenta? Accede",
    "auth_none": "¿No tienes una cuenta? Regístrate",
    "reset_title": "Nueva contraseña",
    "reset_btn": "Guardar la nueva contraseña",
    "reset_done": "Contraseña actualizada. Ahora puedes acceder.",
    "donate_kicker": "Dona",
    "donate_title": "Apoya Una vita da DJ",
    "donate_sub": "Cada aportación alimenta el viaje de esta historia hacia el teatro, el cine y más allá. Elige tu tramo: quedarás para siempre en los créditos finales de nuestro corazón.",
    "donate_btn": "Dona",
    "donate_note": "Pago seguro con Stripe. La donación es libre y no vinculada a la compra del libro.",
    "contact_kicker": "Contactos",
    "contact_title": "Llevemos esta historia más allá de la página",
    "contact_sub": "Para adaptaciones teatrales, cinematográficas, series de TV y plataformas de streaming, derechos editoriales, eventos y presentaciones: escríbenos.",
    "contact_name": "Nombre y apellidos",
    "contact_email": "Tu correo electrónico",
    "contact_topic": "Motivo",
    "contact_message": "Tu mensaje",
    "contact_send": "Enviar mensaje",
    "contact_sent_title": "Mensaje enviado",
    "contact_sent_sub": "¡Gracias! Tu solicitud ha llegado: te responderemos lo antes posible.",
    "topic_teatro": "Teatro",
    "topic_cinema": "Cine",
    "topic_streaming": "Serie / Streaming",
    "topic_editoria": "Edición / Derechos",
    "topic_eventi": "Eventos / Presentaciones",
    "topic_altro": "Otro",
    "pay_ok_title": "Gracias de corazón",
    "pay_ok_unlock": "El libro completo ya está desbloqueado para siempre. Buena lectura en la noche.",
    "pay_ok_donation": "Tu donación ha llegado. Gracias por apoyar esta historia.",
    "pay_ok_wait": "Confirmación del pago en curso…",
    "pay_ok_back": "Volver a las historias",
    "pay_cancel_title": "Pago cancelado",
    "pay_cancel_sub": "No se ha efectuado ningún cargo. Puedes intentarlo de nuevo cuando quieras.",
    "nav_dash": "Panel",
    "dash_title": "Tu panel",
    "dash_sub": "Lectores, desbloqueos, donaciones y mensajes de los productores — todo de un vistazo.",
    "dash_readers": "Lectores",
    "dash_unlocked": "Libro completo desbloqueado — buena noche de lectura",
    "dash_donations": "Donaciones",
    "dash_contacts": "Mensajes",
    "dash_videos": "Vídeos listos",
    "dash_payments": "Tus compras y donaciones",
    "dash_readers_list": "Lectores registrados",
    "dash_contacts_list": "Mensajes de los productores",
    "dash_col_date": "Fecha",
    "dash_col_type": "Tipo",
    "dash_col_amount": "Importe",
    "dash_col_status": "Estado",
    "dash_col_name": "Nombre",
    "dash_col_email": "Correo electrónico",
    "dash_col_topic": "Motivo",
    "dash_col_message": "Mensaje",
    "dash_unlocked_badge": "Desbloqueado",
    "dash_paid": "pagado",
    "dash_pending": "pendiente",
    "dash_failed": "fallido",
    "dash_empty": "Todavía no hay datos",
    "dash_forbidden": "Esta área está reservada al autor.",
    "type_unlock": "Desbloqueo del libro",
    "type_donation": "Donación",
    "en_pending": "La traducción al inglés está en curso — mientras tanto, aquí tienes el original en italiano.",
    "footer_tag": "Una historia de amor entre cabinas y palabras",
    "footer_rights": "Todos los derechos reservados",
    "stories_page_title": "Todas las historias",
    "stories_page_sub": "28 historias · 26 capítulos · introducción y epílogo",
    "watch_mode": "Ver",
    "read_mode": "Leer",
    "watch_desc": "El video short cinematográfico del capítulo",
    "read_desc": "El texto del capítulo, para leer con calma",
    "continue_reading": "Continuar la lectura",
    "resume_from": "Retomar desde",
    "read_badge": "Leído",
    "reading_badge": "Leyendo",
    "card_watch": "Ver",
    "card_read": "Leer",
    "progress_of": "del libro leído",
    "buy_ebook": "eBook · Amazon",
    "buy_paper": "Tapa blanda · ilmiolibro",
    "trailer_kicker": "El tráiler",
    "trailer_title": "Treinta segundos en la noche del '99",
    "trailer_sub": "Los momentos de los 28 vídeos cortos montados en un único tráiler cinematográfico.",
    "share": "Compartir",
    "share_copied": "¡Enlace copiado!",
    "nl_kicker": "Newsletter nocturna",
    "nl_title": "Las noches contadas, en tu email",
    "nl_sub": "Deja tu email: te avisamos cuando lleguen nuevos contenidos, eventos y presentaciones en vivo.",
    "nl_placeholder": "Tu email",
    "nl_btn": "Suscribirme",
    "nl_done": "¡Bienvenido/a al club! Revisa tu correo.",
    "nl_privacy": "Nada de spam, solo noticias sobre el libro. Te das de baja con un clic.",
    "card_download": "Tarjeta de Instagram",
    "b_newsletter": "Newsletter",
    "b_subs": "Suscriptores",
    "b_send_title": "Enviar una actualización a los lectores",
    "b_subject": "Asunto",
    "b_message": "Mensaje",
    "b_send": "Enviar a todos",
    "b_sent": "Newsletter enviada",
    "b_subs_list": "Suscritos al boletín",
    "b_active": "activo",
    "b_unsub": "dado de baja",
    "promo_label": "¿Tienes un código promocional?",
    "promo_placeholder": "Introduce el código",
    "promo_btn": "Activar",
    "promo_ok": "¡Código activado! El libro es todo tuyo.",
    "promo_login": "Inicia sesión o regístrate para usar el código",
    "promo_pay_discounted": "Paga {price} € (−{pct}%)",
    "promo_discount_on": "Descuento del {pct}% activo con el código",
    "promo_only_gift": "Este código desbloquea el libro gratis: úsalo en el cuadro promocional de un capítulo, no aquí",
    "donate_promo_label": "¿Tienes un código de descuento?",
    "donate_promo_btn": "Aplicar",
    "b_promo_discount": "% de descuento (0 = desbloqueo gratis)",
    "b_promo_copy_hint": "Haz clic para copiar",
    "andrea_chat_btn": "Habla con Andrea",
    "andrea_title": "Andrea Perocchi",
    "andrea_sub": "La voz digital del autor — pregúntame por el libro",
    "andrea_welcome": "Bienvenida, bienvenido a la noche. Soy Andrea: ¿quieres saber cómo nació el libro, de qué hablan los capítulos o dónde encontrarlo?",
    "andrea_placeholder": "Escribe a Andrea…",
    "andrea_send": "Enviar",
    "andrea_error": "Perdona, me he distraído un momento detrás de la cabina. Vuelve a intentarlo en breve.",
    "andrea_sug1": "¿Cómo nació este libro?",
    "andrea_sug2": "¿De qué trata?",
    "andrea_sug3": "¿Dónde puedo comprarlo?",
    "auth_recovery_link": "¿No consigues volver a entrar? Otras formas de recuperar la cuenta",
    "rec_title": "Recupera tu cuenta",
    "rec_sub": "Tres maneras de volver a entrar: correo, preguntas de seguridad o SMS.",
    "rec_email_label": "Tu correo electrónico (principal o de recuperación)",
    "rec_by_email": "Por correo electrónico",
    "rec_by_email_sub": "Enlace de restablecimiento a tu correo principal o secundario",
    "rec_by_questions": "Preguntas de seguridad",
    "rec_by_questions_sub": "Responde al menos 4 de 5",
    "rec_by_sms": "Por SMS (1 €)",
    "rec_by_sms_sub": "Código al número guardado en tu perfil",
    "rec_answer_ph": "Tu respuesta",
    "rec_verify": "Verificar respuestas",
    "rec_sms_paid_hint": "Pago recibido: el código está en camino a tu teléfono. Introdúcelo abajo.",
    "rec_sms_code": "Código de 6 dígitos",
    "rec_sms_verify": "Verificar código",
    "rec_new_pw": "Nueva contraseña (mín. 6 caracteres)",
    "rec_reset_btn": "Restablecer contraseña",
    "rec_done": "¡Contraseña restablecida! Ya puedes acceder.",
    "rec_back": "Volver al acceso",
    "dash_security": "Seguridad y recuperación",
    "dash_security_sub": "Si un día olvidas la contraseña o cambias de correo, estas herramientas te ayudarán a volver a entrar.",
    "dash_rec_email": "Correo de recuperación",
    "dash_rec_email_sub": "Una segunda dirección donde recibir el enlace de restablecimiento. Te enviaremos un código para verificarla.",
    "dash_rec_send": "Enviar código",
    "dash_rec_verify": "Verificar código",
    "dash_code_sent": "¡Código enviado! Revisa tu bandeja.",
    "dash_phone": "Teléfono (para SMS)",
    "dash_phone_sub": "Formato internacional con prefijo, p. ej. +393331234567. La recuperación por SMS cuesta 1 €.",
    "dash_phone_save": "Guardar número",
    "dash_remove": "Eliminar",
    "dash_saved": "Guardado ✓",
    "dash_sq": "Preguntas de seguridad",
    "dash_sq_sub": "Elige 5 preguntas y guarda las respuestas: al recuperar la cuenta necesitarás 4 correctas de 5.",
    "dash_sq_set": "Preguntas activas ✓ — vuelve a guardar para cambiarlas.",
    "dash_sq_save": "Guardar preguntas y respuestas",
    "q_first_club": "La primera discoteca en la que entraste",
    "q_first_vinyl": "El primer 45 rpm o CD que compraste",
    "q_childhood_street": "La calle donde vivías de niño/a",
    "q_best_friend": "Tu mejor amigo/a de la infancia",
    "q_first_concert": "El primer concierto al que fuiste",
    "q_mother_name": "El nombre de pila de tu madre",
    "q_first_school": "Tu escuela primaria",
    "q_nickname": "Tu apodo de chico/a",
    "nav_profile": "Mi área personal",
    "nav_admin_section": "Administración",
    "nav_admin_panel": "Panel de administrador",
    "role_admin": "Administrador",
    "role_reader": "Lector",
    "gate_reg_sub_locked": "Inicia sesión o regístrate gratis: luego podrás desbloquear este capítulo o usar un código promocional.",
    "b_promos": "Códigos promocionales",
    "b_promo_create": "Crear código",
    "b_promo_days": "Días de validez",
    "b_promo_optional": "Código (vacío = automático)",
    "b_promo_expires": "caduca el",
    "b_promo_uses": "usos",
    "b_promo_auto": "automático",
    "b_promo_note": "Reglas automáticas: tras 14 días sin ventas se crea un código de 7 días y se envía al boletín.",
    "b_promo_free": "Tipo: desbloqueo GRATIS (sin pago)", "b_promo_kind_discount": "Tipo: descuento en el pago", "b_promo_free_badge": "gratis",
    "b_promo_suspended": "suspendido", "b_promo_suspend": "Suspender (inutilizable, sigue en la lista)", "b_promo_resume": "Reactivar",
    "dash_col_actions": "Acciones", "dash_refund": "Reembolsar", "dash_refunded": "reembolsado",
    "dash_refund_confirm": "¿Reembolsar este pago? El cliente recibirá el reembolso completo y, si era un desbloqueo, perderá el acceso al libro.",
    "b_invoices": "Facturas y recibos",
    "b_inv_settings": "Configuración de Fatture in Cloud",
    "b_inv_where": "Crea el token en developers.fattureincloud.it (ámbitos issued_documents) y toma el Company ID de tu cuenta.",
    "b_inv_configured": "configurado ✓", "b_inv_not_configured": "por configurar",
    "b_inv_token": "Token de acceso de Fatture in Cloud", "b_inv_token_set": "Token guardado ✓ (déjalo vacío para no cambiarlo)",
    "b_inv_company": "Company ID", "b_inv_paymethod": "ID método de pago", "b_inv_vat": "ID tipo de IVA (0 = 22%)",
    "b_inv_next_f": "Próximo n. factura", "b_inv_next_r": "Próximo n. recibo",
    "b_inv_save": "Guardar", "b_inv_test": "Probar conexión", "b_inv_saved": "Configuración guardada ✓", "b_inv_test_ok": "Conexión correcta ✓",
    "b_inv_requests": "Solicitudes de documentos",
    "b_inv_st_requested": "esperando datos", "b_inv_st_data_submitted": "datos listos", "b_inv_st_issued": "emitida", "b_inv_st_failed": "fallida",
    "b_inv_issue": "Emitir", "b_inv_retry": "Reintentar",
    "b_inv_send": "Factura", "b_inv_send_hint": "Envía al cliente por email la solicitud de datos fiscales",
    "pay_ok_invoice": "Solicitar factura o recibo",
    "inv_title": "Datos fiscales", "inv_sub": "Documento para el pago de", "inv_not_found": "Solicitud no encontrada o enlace no válido.",
    "inv_kind": "Tipo de documento", "inv_kind_invoice": "Factura", "inv_kind_receipt": "Recibo",
    "inv_name": "Nombre y apellidos / Razón social", "inv_street": "Dirección (calle y número)",
    "inv_cap": "Código postal", "inv_city": "Ciudad", "inv_province": "Prov.", "inv_country": "País",
    "inv_vat": "NIF / IVA", "inv_cf": "Código fiscal", "inv_vat_hint": "Para la factura hace falta al menos uno de los dos.",
    "inv_sdi": "Código SDI (opcional)", "inv_pec": "PEC (opcional)",
    "inv_submit": "Enviar datos", "inv_sending": "Enviando…",
    "inv_done": "¡Datos recibidos! Emitiremos el documento y te lo enviaremos por email.",
    "footer_book_online": "¿Quieres tu libro online?",
    "bo_kicker": "Para autores y editoriales", "bo_title": "¿Quieres tu libro online, así?",
    "bo_sub": "Este sitio es una demostración viva de lo que puede llegar a ser un libro: una experiencia multimedia navegable. Si has escrito una novela, un ensayo o una historia que contar, podemos construir juntos un proyecto como este.",
    "bo_f1t": "El libro en historias", "bo_f1d": "Cada capítulo se convierte en una historia para leer online, con marcadores, progreso de lectura y capítulos gratuitos para conquistar nuevos lectores.",
    "bo_f2t": "Vídeos cortos cinematográficos", "bo_f2d": "Cada historia cobra vida en un breve vídeo generado con inteligencia artificial, con subtítulos en varios idiomas.",
    "bo_f3t": "Narración en audio", "bo_f3d": "Los capítulos se escuchan como un pódcast: voces generadas en italiano, inglés, español y chino.",
    "bo_f4t": "El autor responde", "bo_f4d": "Un asistente con la voz y los recuerdos del autor conversa con los lectores, respondiendo en su idioma.",
    "bo_f5t": "Cuatro idiomas", "bo_f5d": "Interfaz, textos, audio y vídeo traducidos: tu libro habla al mundo entero.",
    "bo_f6t": "Venta y apoyo", "bo_f6d": "Paywall elegante, códigos promocionales, donaciones y pagos seguros: el proyecto se sostiene solo.",
    "bo_cta": "Cuéntanos tu proyecto", "bo_cta_sub": "Escríbenos desde la página de contacto: te respondemos en persona, como debe ser.",
    "footer_bo_desc": "Convierte tu libro en una experiencia multimedia como esta: historias, vídeos, audio y venta online.",
    "dash_level_title": "Tu nivel de acceso",
    "dash_level_registered": "Lector registrado", "dash_level_partial": "Acceso ampliado con código", "dash_level_full": "Libro completo",
    "dash_level_registered_desc": "Puedes leer gratis la introducción y los capítulos 1–5.",
    "dash_level_partial_desc": "Gracias a tu código puedes leer los primeros {n} capítulos.",
    "dash_level_full_desc": "Tienes acceso a todas las historias, vídeos y audios.",
    "dash_level_chapters": "capítulos",
    "verify_title": "Certifica tu cuenta", "verify_sub": "Te enviamos un código de 6 dígitos por email. Introdúcelo aquí para certificar",
    "verify_btn": "Certificar cuenta", "verify_resend": "Reenviar código", "verify_resent": "Código reenviado ✓",
    "verify_done": "Tu cuenta está certificada. Buenas noches y buena lectura.", "verify_continue": "Ir a tu área",
    "verify_wrong": "Código no válido", "verify_needed": "Debes certificar tu email para poder comentar.", "verify_link": "Certificar ahora",
    "flash_title": "Lanzamiento relámpago de 48 horas:",
    "flash_sub": "el libro completo gratis con el código",
    "flash_cta": "Usa el código",
    "b_errors": "Errores del sitio",
    "b_no_errors": "No hay errores registrados — todo va sobre ruedas.",
    "b_suspend": "Suspender",
    "b_unsuspend": "Reactivar",
    "b_suspended": "suspendido",
    "b_reading": "Lecturas",
    "read_part": "Parte",
    "bookmark_add": "Añadir un marcador",
    "bookmark_saved": "Marcador guardado",
    "bookmarks": "Tus marcadores en este capítulo",
    "dona_benefit_5": "lee 3 capítulos más",
    "dona_benefit_20": "todo el libro desbloqueado",
    "dona_benefit_50": "libro + 1 copia de regalo",
    "dona_benefit_100": "libro + 2 copias de regalo",
    "dona_benefit_1000": "libro + 3 copias de regalo",
    "codes_title": "Tus códigos",
    "code_yours": "Tu código — actívalo para desbloquear",
    "code_gift": "Copia de regalo para un amigo/a",
    "code_copy": "Copiar",
    "code_copied": "¡Copiado!",
    "code_howto": "Cada código se activa en la página de un capítulo, en el recuadro “¿Tienes un código promo?”, después del registro gratuito.",
    "code_grant_full": "Libro completo",
    "code_grant_chapters8": "3 capítulos más",
    "gate_video_register": "Regístrate para continuar",
    "gate_video_sub": "Has visto la vista previa de 5 segundos. La noche entera te espera dentro.",
    "bm_note_placeholder": "Una frase para recordar por qué precisamente aquí…",
    "bm_save": "Guardar",
    "bm_skip": "Sin nota",
    "comments_title": "Comentarios de los lectores",
    "comments_sub": "Solo son visibles los comentarios aprobados por el autor.",
    "comments_placeholder": "¿Qué te ha dejado este capítulo?",
    "comments_send": "Enviar comentario",
    "comments_pending": "¡Gracias! Tu comentario será visible tras la aprobación.",
    "comments_verified": "Lector certificado",
    "comments_login": "Inicia sesión para dejar un comentario",
    "comments_empty": "Todavía no hay comentarios. Escribe el primero.",
    "b_comments": "Comentarios",
    "b_publish": "Publicar",
    "b_unpublish": "Ocultar",
    "b_published": "publicado",
    "b_pending": "pendiente",
    "g_title": "Guardián del sitio",
    "g_sub": "Cada hora comprueba errores y navegación, repara por sí solo lo que es seguro y lo registra todo abajo. Las correcciones de código te las propone: las aplicamos juntos.",
    "g_errors": "Errores 24 h",
    "g_events": "Eventos 24 h",
    "g_mailq": "Emails en cola",
    "g_paid": "Pagos ok",
    "g_funnel": "Embudo de navegación (24 h)",
    "g_views": "páginas vistas",
    "g_unlocks": "clics de desbloqueo",
    "g_donations": "clics de donación",
    "g_cancelled": "cancelados",
    "g_top_errors": "Errores más frecuentes",
    "g_no_errors": "No hay errores en las últimas 24 horas. Todo fluye.",
    "g_diagnosis": "Último diagnóstico del Guardián",
    "g_run": "Ejecutar comprobación ahora",
    "g_running": "Comprobación en curso…",
    "g_actions": "Registro de actividad del Guardián",
    "g_rollback": "Deshacer",
    "g_rolled": "deshecha",
    "g_no_actions": "Aún no hay acciones. En la primera comprobación encontrarás aquí cada intervención.",
    "g_versions": "Versiones del sitio",
    "g_restore": "Solicitar retorno",
    "g_restore_sent": "Solicitud registrada",
    "rs_title": "Estadísticas de lectores",
    "rs_sub": "Cuántos empiezan cada capítulo, cuántos lo terminan, dónde se detienen.",
    "rs_readers": "lectores registrados",
    "rs_unlocked": "libros completos desbloqueados",
    "rs_started": "empezado",
    "rs_finished": "terminado",
    "rs_avg": "lectura media",
    "rs_no_data": "Aún no hay lecturas registradas: las barras se llenarán con el boca a boca.",
    "dash_hello": "Hola",
    "dash_reader_sub": "Tu espacio personal: tus lecturas, tus marcadores, tus compras. Solo tú ves estos datos.",
    "dash_locked": "Aún no tienes el libro completo",
    "dash_unlock_cta": "Desbloquear por 10 €",
    "dash_chapters": "Tus capítulos",
    "dash_bookmarks": "Tus marcadores",
    "dash_my_payments": "Tus donaciones y tu libro",
    "dash_account": "Tu cuenta",
    "dash_cur_pw": "Contraseña actual (si la tienes)",
    "dash_new_pw": "Nueva contraseña",
    "dash_change_pw": "Cambiar contraseña",
    "dash_pw_ok": "¡Contraseña actualizada!",
    "dash_new_email": "Nuevo correo",
    "dash_change_email": "Cambiar correo",
    "dash_email_ok": "¡Correo actualizado!",
    "dash_pw_for_email": "Confirma con tu contraseña",
    "dash_empty_reading": "Todavía no has empezado ningún capítulo. La noche te espera.",
    "dash_empty_bm": "Aún no hay marcadores.",
    "dash_empty_pay": "Aún no hay compras ni donaciones.",
    "dash_admin_link": "Panel del autor",
    "ei_kicker": "Sostenedor del libro",
    "ei_tagline": "Quien cree en esta historia, del código a la cabina",
    "ei_p1": "EI SRL — Enterimprese (enterimprese.it) es una empresa romana de desarrollo de software y servicios digitales B2B. «¿Tienes un proyecto? Te escuchamos y lo hacemos realidad» es su promesa: desde las telecomunicaciones hasta los datacenters, desde las apps hasta los sitios web, pasando por la estrategia de marca.",
    "ei_p2": "Enterimprese apoya Una vita da DJ y ha hecho posible su plataforma digital: el sitio, los vídeos cortos cinematográficos y la experiencia de lectura que estás viviendo nacen de esta colaboración entre página y código.",
    "ei_hq": "Sede",
    "ei_vat": "Datos fiscales",
    "ei_web": "Web",
    "ei_svc_tlc": "Agencia TLC",
    "ei_svc_cloud": "Datacenter y Cloud",
    "ei_svc_app": "Desarrollo de apps",
    "ei_svc_web": "Creación de sitios web",
    "ei_svc_brand": "Estrategia de marca",
    "ei_svc_seo": "SEO y web marketing",
    "footer_sponsor": "Con el apoyo de",
    "dona_tier_5_title": "El café del DJ",
    "dona_tier_5_desc": "Desbloquea al instante 8 capítulos online con tu código personal.",
    "dona_tier_20_title": "Toda la noche",
    "dona_tier_20_desc": "El libro completo online + 1 código de regalo para un amigo.",
    "dona_tier_50_title": "El libro impreso en casa",
    "dona_tier_50_desc": "Todo online + el libro impreso enviado a tu casa + 1 código de regalo.",
    "dona_tier_100_title": "De colección",
    "dona_tier_100_desc": "Ejemplar firmado enviado a casa + 2 códigos de regalo + tu nombre en los agradecimientos del sitio.",
    "dona_tier_1000_title": "Mecenas de la noche",
    "dona_tier_1000_desc": "5 ejemplares impresos para ti o para regalar + 3 códigos + mención especial en el viaje hacia el teatro y el cine.",
    "dona_ship_note": "A partir de 50 €, el libro impreso llega a tu casa: te escribimos nosotros para la dirección de envío.",
    "b_notify_title": "Copia de notificaciones",
    "b_notify_sub": "Cada email enviado por la plataforma llega en copia oculta (CCO) a esta dirección.",
    "b_notify_save": "Guardar",
    "b_notify_saved": "Guardado ✓",
    "b_co_title": "Datos de la empresa",
    "b_co_sub": "Datos fiscales y societarios. En el sitio público solo aparecen razón social, país y número de IVA; dirección y SDI quedan aquí.",
    "b_co_name": "Razón social",
    "b_co_country": "País",
    "b_co_vat": "N.º de IVA",
    "b_co_sdi": "Código SDI",
    "b_co_addr": "Dirección de la sede (no pública)",
    "b_co_web": "Sitio web",
    "b_co_email": "Email de la empresa",
    "b_co_ts": "Clave secreta Turnstile (anti-bot)",
    "back_top": "Volver arriba",
    "dash_email_pending": "Código enviado al nuevo email ✓ — hasta que lo confirmes, el acceso sigue con el email anterior.",
    "dash_email_confirm_hint": "Introduce el código de 6 dígitos enviado a la nueva dirección (válido 15 minutos).",
    "dash_email_confirm_btn": "Confirmar cambio de email"
  },
  "zh": {
    "nav_stories": "故事",
    "nav_shorts": "短视频",
    "nav_author": "作者",
    "nav_donate": "支持",
    "nav_contact": "联系",
    "nav_cta": "阅读小说",
    "nav_login": "登录",
    "nav_logout": "退出",
    "hero_kicker": "Andrea Perocchi 的一部小说",
    "hero_sub": "一个爱情故事",
    "hero_tag": "夜色、灯光、节奏。一个发生在唱盘与文字之间、罗马与伦敦之间、世纪末尾的爱情故事。",
    "hero_cta1": "开始阅读",
    "hero_cta2": "观看短视频",
    "stat_stories": "故事",
    "stat_chapters": "章节",
    "stat_cities": "罗马 ↔ 伦敦",
    "stat_pages": "页数",
    "marquee": "夜晚 · 灯光 · 节奏 · 爱情 · 音乐 · 罗马 · 伦敦 · GIULIA & ALEX · 26 章 · 命运 · ",
    "novel_kicker": "这部小说",
    "novel_title": "命运推动他们踏上一段旅程，幸福成为真正的收获",
    "novel_text": "Alex 把唱盘变成一个脉动不息的宇宙，Giulia 则在旅途、学业与新的生活选择之间追寻答案。他们的相遇看似偶然，而命运却推动他们踏上一段旅程，幸福成为真正的收获。在派对、秘密与意外转折之间，Una vita da DJ 讲述爱情与音乐如何改变一切。",
    "stories_kicker": "书中的故事",
    "stories_title": "二十八个故事，两种声音，同一段节奏",
    "stories_sub": "每一章都是一个可读也可看的故事。你可以按叙述者筛选，让自己被夜色带走。",
    "stories_all": "阅读全部故事",
    "filter_all": "全部",
    "shorts_kicker": "短视频",
    "shorts_title": "故事被赋予生命",
    "shorts_sub": "每个故事都有属于它的电影感短片：动态字体、节奏与唱盘般的灯光。按下播放。",
    "shorts_watch": "观看短片",
    "support_kicker": "支持这个故事",
    "support_title": "从书页到舞台",
    "support_sub": "这个故事梦想着登上戏剧与银幕。若它曾让你心动，你可以用一笔自由捐助来支持它。",
    "support_cta": "捐助支持",
    "author_kicker": "作者",
    "author_title": "在唱盘背后，Andrea Perocchi",
    "author_cta": "认识作者",
    "story_excerpt": "章节摘录",
    "story_full": "全文",
    "story_prev": "上一则故事",
    "story_next": "下一则故事",
    "story_back": "所有故事",
    "story_continue": "故事在书中继续",
    "gate_reg_title": "继续免费阅读",
    "gate_reg_sub": "免费注册，即可在这里直接阅读第3、4、5章完整内容。",
    "gate_reg_btn": "免费注册",
    "gate_pay_title": "夜色继续",
    "gate_pay_sub": "解锁整本书——全部26章及尾声，永久拥有。",
    "gate_pay_btn": "以10 €解锁",
    "gate_donate_hint": "或者用自由捐助支持这个项目",
    "player_short": "短视频",
    "player_note": "根据章节文本生成的电影感短片",
    "player_audio": "音频",
    "video_ai_btn": "生成AI视频",
    "video_processing": "AI视频生成中…",
    "video_error": "生成失败",
    "chapter_word": "第",
    "read": "阅读",
    "author_role": "DJ · 作者",
    "author_p1": "Andrea Perocchi（罗马，1972）是一位营销、电信与人工智能顾问，同时也是出版人、作家和唱片骑师。作为一位出版人的儿子，他创办了 Radio Data Network——意大利最早的互联网服务提供商之一——并曾主编 Radiolink 和 Carte 等专业杂志。",
    "author_p2": "在九十年代，他以 Double Andy DJ 的艺名活跃于罗马与意大利各地俱乐部的唱盘前，并在 Spazio Radio 主持电台节目。热爱帆船、电影与绘画的他，于 2025 年出版了《Una vita da DJ》和《Vento a Prua》，把自己生命中的夜晚、音乐与海洋化作小说。",
    "author_facts": "唱盘台",
    "fact_1": "Double Andy DJ",
    "fact_2": "90年代电台与俱乐部",
    "fact_3": "帆船与写作",
    "author_opere": "作品",
    "author_unpublished": "未出版",
    "buy_title": "在哪里找到这本书",
    "buy_note": "《Una vita da DJ》——一个爱情故事 · FM Editing, 2025",
    "buy_cta": "作者页面",
    "auth_login_title": "欢迎回到夜色里",
    "auth_register_title": "进入俱乐部",
    "auth_name": "姓名",
    "auth_email": "邮箱",
    "auth_password": "密码",
    "auth_login_btn": "登录",
    "auth_register_btn": "免费注册",
    "auth_forgot": "忘记密码？",
    "auth_forgot_btn": "发送重置链接",
    "auth_forgot_sent": "如果邮箱已注册，你将在几分钟内收到链接。",
    "auth_or": "或者",
    "auth_google": "使用 Google 继续",
    "auth_have": "已有账号？登录",
    "auth_none": "还没有账号？注册",
    "reset_title": "新密码",
    "reset_btn": "保存新密码",
    "reset_done": "密码已更新。现在可以登录了。",
    "donate_kicker": "捐助",
    "donate_title": "支持 Una vita da DJ",
    "donate_sub": "每一份支持，都会为这部故事走向戏剧、电影以及更远的旅程添一把火。请选择你的份额：你将永远写进我们心的片尾字幕里。",
    "donate_btn": "捐赠",
    "donate_note": "通过 Stripe 安全支付。捐赠完全自愿，不与购书绑定。",
    "contact_kicker": "联系",
    "contact_title": "让这个故事走出纸页",
    "contact_sub": "如需舞台改编、电影、电视剧与流媒体平台合作、出版版权、活动与发布会信息，请写信给我们。",
    "contact_name": "姓名",
    "contact_email": "你的邮箱",
    "contact_topic": "事由",
    "contact_message": "你的留言",
    "contact_send": "发送消息",
    "contact_sent_title": "消息已发送",
    "contact_sent_sub": "谢谢！你的请求已收到：我们会尽快回复。",
    "topic_teatro": "戏剧",
    "topic_cinema": "电影",
    "topic_streaming": "剧集 / 流媒体",
    "topic_editoria": "出版 / 版权",
    "topic_eventi": "活动 / 发布会",
    "topic_altro": "其他",
    "pay_ok_title": "衷心感谢",
    "pay_ok_unlock": "整本书现已永久解锁。祝你在夜色中阅读愉快。",
    "pay_ok_donation": "你的捐赠已收到。感谢你支持这个故事。",
    "pay_ok_wait": "正在确认付款…",
    "pay_ok_back": "返回故事",
    "pay_cancel_title": "付款已取消",
    "pay_cancel_sub": "未产生任何扣款。你可以随时重试。",
    "nav_dash": "仪表板",
    "dash_title": "你的仪表板",
    "dash_sub": "读者、解锁、捐赠和来自制片方的消息——一目了然。",
    "dash_readers": "读者",
    "dash_unlocked": "整本书已解锁——祝你夜读愉快",
    "dash_donations": "捐赠",
    "dash_contacts": "消息",
    "dash_videos": "已准备好的视频",
    "dash_payments": "你的购买与捐赠",
    "dash_readers_list": "已注册读者",
    "dash_contacts_list": "制作人的消息",
    "dash_col_date": "日期",
    "dash_col_type": "类型",
    "dash_col_amount": "金额",
    "dash_col_status": "状态",
    "dash_col_name": "姓名",
    "dash_col_email": "电子邮箱",
    "dash_col_topic": "原因",
    "dash_col_message": "消息",
    "dash_unlocked_badge": "已解锁",
    "dash_paid": "已支付",
    "dash_pending": "待处理",
    "dash_failed": "失败",
    "dash_empty": "暂无数据",
    "dash_forbidden": "此区域仅限作者。",
    "type_unlock": "图书解锁",
    "type_donation": "捐赠",
    "en_pending": "英文翻译正在进行中——先奉上意大利文原文。",
    "footer_tag": "一段关于唱盘与文字之间的爱情故事",
    "footer_rights": "保留所有权利",
    "stories_page_title": "所有故事",
    "stories_page_sub": "28 个故事 · 26 章 · 序章与尾声",
    "watch_mode": "观看",
    "read_mode": "阅读",
    "watch_desc": "本章的电影感短视频",
    "read_desc": "章节正文，请慢慢阅读",
    "continue_reading": "继续阅读",
    "resume_from": "从此处继续",
    "read_badge": "已读",
    "reading_badge": "阅读中",
    "card_watch": "观看",
    "card_read": "阅读",
    "progress_of": "本书已读",
    "buy_ebook": "电子书 · Amazon",
    "buy_paper": "纸质书 · ilmiolibro",
    "trailer_kicker": "预告片",
    "trailer_title": "1999年夜色中的三十秒",
    "trailer_sub": "28段短视频的片段，剪辑成一支电影感预告片。",
    "share": "分享",
    "share_copied": "链接已复制！",
    "nl_kicker": "夜间通讯",
    "nl_title": "那些夜晚，写进你的邮箱",
    "nl_sub": "留下你的邮箱：当有新内容、活动和线下发布会时，我们会通知你。",
    "nl_placeholder": "你的邮箱",
    "nl_btn": "订阅",
    "nl_done": "欢迎加入俱乐部！请查看你的邮箱。",
    "nl_privacy": "没有垃圾邮件，只有与本书有关的消息。你可随时一键取消订阅。",
    "card_download": "Instagram 卡片",
    "b_newsletter": "通讯",
    "b_subs": "订阅者",
    "b_send_title": "向读者发送更新",
    "b_subject": "主题",
    "b_message": "消息",
    "b_send": "发送给所有人",
    "b_sent": "通讯已发送",
    "b_subs_list": "通讯订阅者",
    "b_active": "有效",
    "b_unsub": "已取消订阅",
    "promo_label": "有促销码吗？",
    "promo_placeholder": "输入代码",
    "promo_btn": "激活",
    "promo_ok": "代码已激活！这本书现在完全属于你。",
    "promo_login": "请登录或注册后使用该代码",
    "promo_pay_discounted": "支付 {price} €（−{pct}%）",
    "promo_discount_on": "使用该代码可享 {pct}% 折扣",
    "promo_only_gift": "此代码可解锁本书免费阅读：请在章节的促销框中使用，不要在这里使用",
    "donate_promo_label": "有折扣码吗？",
    "donate_promo_btn": "应用",
    "b_promo_discount": "折扣%（0 = 免费解锁）",
    "b_promo_copy_hint": "点击复制",
    "andrea_chat_btn": "与 Andrea 对话",
    "andrea_title": "Andrea Perocchi",
    "andrea_sub": "作者的数字声音——来问我这本书吧",
    "andrea_welcome": "欢迎来到夜色中。我是 Andrea：你想了解这本书是如何诞生的、各章节讲什么，还是在哪里能找到它？",
    "andrea_placeholder": "给 Andrea 写信……",
    "andrea_send": "发送",
    "andrea_error": "抱歉，我刚才在控制台后走了个神。请稍后再试。",
    "andrea_sug1": "这本书是如何诞生的？",
    "andrea_sug2": "它讲的是什么？",
    "andrea_sug3": "我可以在哪里买到？",
    "auth_recovery_link": "无法重新登录？其他找回账户的方式",
    "rec_title": "找回你的账户",
    "rec_sub": "三种重新进入的方式：电子邮件、安全问题或短信。",
    "rec_email_label": "你的邮箱（主邮箱或恢复邮箱）",
    "rec_by_email": "通过电子邮件",
    "rec_by_email_sub": "将重置链接发送到你的主邮箱或备用邮箱",
    "rec_by_questions": "安全问题",
    "rec_by_questions_sub": "请回答 5 题中的至少 4 题",
    "rec_by_sms": "通过短信（1 €）",
    "rec_by_sms_sub": "验证码会发送到你资料中保存的号码",
    "rec_answer_ph": "你的答案",
    "rec_verify": "验证答案",
    "rec_sms_paid_hint": "付款已收到：验证码正在发送到你的手机。请在下方输入。",
    "rec_sms_code": "6 位验证码",
    "rec_sms_verify": "验证验证码",
    "rec_new_pw": "新密码（至少 6 个字符）",
    "rec_reset_btn": "重设密码",
    "rec_done": "密码已重设！现在你可以登录了。",
    "rec_back": "返回登录",
    "dash_security": "安全与找回",
    "dash_security_sub": "如果有一天你忘记密码或更换邮箱，这些工具会帮你顺利返回。",
    "dash_rec_email": "找回邮箱",
    "dash_rec_email_sub": "用于接收重置链接的第二个地址。我们会发送验证码进行验证。",
    "dash_rec_send": "发送验证码",
    "dash_rec_verify": "验证验证码",
    "dash_code_sent": "验证码已发送！请检查收件箱。",
    "dash_phone": "电话（用于短信）",
    "dash_phone_sub": "请使用带国际区号的格式，例如 +393331234567。短信找回费用为 1 €。",
    "dash_phone_save": "保存号码",
    "dash_remove": "移除",
    "dash_saved": "已保存 ✓",
    "dash_sq": "安全问题",
    "dash_sq_sub": "请选择 5 个问题并保存答案：找回时需要 5 题中答对 4 题。",
    "dash_sq_set": "问题已启用 ✓ — 如需更改，请重新保存。",
    "dash_sq_save": "保存问题和答案",
    "q_first_club": "你第一次走进的夜店",
    "q_first_vinyl": "你买下的第一张45转唱片或CD",
    "q_childhood_street": "你童年时住的那条街",
    "q_best_friend": "你童年最好的朋友",
    "q_first_concert": "你第一次去的演唱会",
    "q_mother_name": "你母亲的名字",
    "q_first_school": "你的小学",
    "q_nickname": "你少年时的绰号",
    "nav_profile": "我的个人空间",
    "nav_admin_section": "管理",
    "nav_admin_panel": "管理员面板",
    "role_admin": "管理员",
    "role_reader": "读者",
    "gate_reg_sub_locked": "登录或免费注册：之后你就可以解锁这一章，或使用促销码。",
    "b_promos": "促销码",
    "b_promo_create": "创建代码",
    "b_promo_days": "有效天数",
    "b_promo_optional": "代码（留空=自动生成）",
    "b_promo_expires": "到期于",
    "b_promo_uses": "次使用",
    "b_promo_auto": "自动",
    "b_promo_note": "自动规则：连续14天没有销售后，会生成一个有效期7天的代码，并发送到新闻邮件。",
    "b_promo_free": "类型：免费解锁（无需付款）", "b_promo_kind_discount": "类型：付款折扣", "b_promo_free_badge": "免费",
    "b_promo_suspended": "已暂停", "b_promo_suspend": "暂停（无法使用，保留在列表中）", "b_promo_resume": "重新启用",
    "dash_col_actions": "操作", "dash_refund": "退款", "dash_refunded": "已退款",
    "dash_refund_confirm": "确定要退还此款项吗？客户将收到全额退款；如果是解锁购买，将失去对本书的访问权限。",
    "b_invoices": "发票与收据",
    "b_inv_settings": "Fatture in Cloud 配置",
    "b_inv_where": "在 developers.fattureincloud.it 创建令牌（issued_documents 权限），并从您的账户获取 Company ID。",
    "b_inv_configured": "已配置 ✓", "b_inv_not_configured": "未配置",
    "b_inv_token": "Fatture in Cloud 访问令牌", "b_inv_token_set": "令牌已保存 ✓（留空则不更改）",
    "b_inv_company": "Company ID", "b_inv_paymethod": "支付方式 ID", "b_inv_vat": "增值税税率 ID（0 = 22%）",
    "b_inv_next_f": "下一张发票编号", "b_inv_next_r": "下一张收据编号",
    "b_inv_save": "保存", "b_inv_test": "测试连接", "b_inv_saved": "配置已保存 ✓", "b_inv_test_ok": "连接成功 ✓",
    "b_inv_requests": "单据申请",
    "b_inv_st_requested": "等待数据", "b_inv_st_data_submitted": "数据就绪", "b_inv_st_issued": "已开具", "b_inv_st_failed": "失败",
    "b_inv_issue": "开具", "b_inv_retry": "重试",
    "b_inv_send": "发票", "b_inv_send_hint": "通过电子邮件向客户发送财税数据填写请求",
    "pay_ok_invoice": "申请发票或收据",
    "inv_title": "财税信息", "inv_sub": "此付款的单据，金额", "inv_not_found": "未找到申请或链接无效。",
    "inv_kind": "单据类型", "inv_kind_invoice": "发票", "inv_kind_receipt": "收据",
    "inv_name": "姓名 / 公司名称", "inv_street": "地址（街道和门牌号）",
    "inv_cap": "邮编", "inv_city": "城市", "inv_province": "省/州", "inv_country": "国家",
    "inv_vat": "增值税号", "inv_cf": "税号", "inv_vat_hint": "发票至少需要其中一项。",
    "inv_sdi": "SDI 代码（可选）", "inv_pec": "PEC 邮箱（可选）",
    "inv_submit": "提交信息", "inv_sending": "提交中…",
    "inv_done": "信息已收到！我们将开具单据并通过电子邮件发送给您。",
    "footer_book_online": "想让您的书上线吗？",
    "bo_kicker": "面向作者与出版商", "bo_title": "想让您的书也这样上线吗？",
    "bo_sub": "这个网站就是一本书所能成为的样子的生动示范：可浏览的多媒体体验。如果您写了一部小说、一本随笔或一个值得讲述的故事，我们可以一起打造这样的项目。",
    "bo_f1t": "把书变成故事", "bo_f1d": "每个章节都成为一个可在线阅读的故事，带书签、阅读进度和免费章节，吸引更多读者。",
    "bo_f2t": "电影感短视频", "bo_f2d": "每个故事都会化为由人工智能生成的短视频，配有多语言字幕。",
    "bo_f3t": "音频朗读", "bo_f3d": "章节可以像播客一样收听：提供意大利语、英语、西班牙语和中文的朗读声音。",
    "bo_f4t": "作者亲自回应", "bo_f4d": "一个承载着作者声音与记忆的助手与读者对话，并用读者的语言作答。",
    "bo_f5t": "四种语言", "bo_f5d": "界面、文本、音频和视频全部翻译：您的书与全世界对话。",
    "bo_f6t": "销售与支持", "bo_f6d": "优雅的付费墙、优惠码、捐赠和安全支付：项目自我维持。",
    "bo_cta": "告诉我们您的项目", "bo_cta_sub": "通过联系页面给我们留言：我们会亲自回复。",
    "footer_bo_desc": "把您的书变成像这样的多媒体体验：故事、视频、音频和在线销售。",
    "dash_level_title": "您的访问级别",
    "dash_level_registered": "注册读者", "dash_level_partial": "优惠码扩展访问", "dash_level_full": "完整书籍",
    "dash_level_registered_desc": "您可以免费阅读序言和第1–5章。",
    "dash_level_partial_desc": "凭借您的优惠码，您可以阅读前{n}章。",
    "dash_level_full_desc": "您可以访问所有故事、视频和音频。",
    "dash_level_chapters": "章节",
    "verify_title": "验证您的账户", "verify_sub": "我们已向您的邮箱发送了6位验证码，请在此输入以完成验证",
    "verify_btn": "验证账户", "verify_resend": "重新发送验证码", "verify_resent": "验证码已重新发送 ✓",
    "verify_done": "您的账户已验证。晚安，祝您阅读愉快。", "verify_continue": "前往我的专区",
    "verify_wrong": "验证码无效", "verify_needed": "评论前请先验证您的邮箱。", "verify_link": "立即验证",
    "flash_title": "48小时闪购：",
    "flash_sub": "使用代码即可免费获得整本书",
    "flash_cta": "使用代码",
    "b_errors": "网站错误",
    "b_no_errors": "未记录错误——一切顺畅。",
    "b_suspend": "暂停",
    "b_unsuspend": "重新启用",
    "b_suspended": "已暂停",
    "b_reading": "阅读",
    "read_part": "部分",
    "bookmark_add": "添加书签",
    "bookmark_saved": "书签已保存",
    "bookmarks": "你在本章的书签",
    "dona_benefit_5": "再读 3 章",
    "dona_benefit_20": "解锁整本书",
    "dona_benefit_50": "书籍 + 1 份赠送副本",
    "dona_benefit_100": "书籍 + 2 份赠送副本",
    "dona_benefit_1000": "书籍 + 3 份赠送副本",
    "codes_title": "你的代码",
    "code_yours": "你的代码——激活即可解锁",
    "code_gift": "送给朋友的礼物副本",
    "code_copy": "复制",
    "code_copied": "已复制！",
    "code_howto": "每个代码都可在章节页面中的“有促销码？”框里激活，免费注册后即可使用。",
    "code_grant_full": "完整书籍",
    "code_grant_chapters8": "再加 3 章",
    "gate_video_register": "注册后继续",
    "gate_video_sub": "你已看过 5 秒预览。整夜故事正在里面等你。",
    "bm_note_placeholder": "留下一句话，记住为何偏偏是这里……",
    "bm_save": "保存",
    "bm_skip": "无需备注",
    "comments_title": "读者评论",
    "comments_sub": "仅显示作者已批准的评论。",
    "comments_placeholder": "这章给你留下了什么？",
    "comments_send": "发送评论",
    "comments_pending": "谢谢！你的评论将在审核通过后显示。",
    "comments_verified": "已认证读者",
    "comments_login": "登录后发表评论",
    "comments_empty": "还没有评论。来写第一条吧。",
    "b_comments": "评论",
    "b_publish": "发布",
    "b_unpublish": "隐藏",
    "b_published": "已发布",
    "b_pending": "等待中",
    "g_title": "网站守护者",
    "g_sub": "每小时检查错误与浏览情况，自动修复安全问题，并将一切记录在下方。代码修正由它先提出，我们一起应用。",
    "g_errors": "24小时错误",
    "g_events": "24小时事件",
    "g_mailq": "排队邮件",
    "g_paid": "付款正常",
    "g_funnel": "浏览漏斗（24小时）",
    "g_views": "浏览页面",
    "g_unlocks": "解锁点击",
    "g_donations": "捐赠点击",
    "g_cancelled": "已取消",
    "g_top_errors": "最常见错误",
    "g_no_errors": "过去24小时内没有错误。一切顺畅。",
    "g_diagnosis": "守护者的最后诊断",
    "g_run": "立即运行检查",
    "g_running": "检查中…",
    "g_actions": "守护者活动记录",
    "g_rollback": "撤销",
    "g_rolled": "已撤销",
    "g_no_actions": "目前还没有任何操作。第一次检查后，这里会记录每一次处理。",
    "g_versions": "网站版本",
    "g_restore": "请求恢复",
    "g_restore_sent": "请求已记录",
    "rs_title": "读者统计",
    "rs_sub": "每一章有多少人开始阅读，有多少人读完，又在哪里停下。",
    "rs_readers": "注册读者",
    "rs_unlocked": "已解锁完整书籍",
    "rs_started": "已开始",
    "rs_finished": "已读完",
    "rs_avg": "平均阅读",
    "rs_no_data": "尚无阅读记录：口碑相传后，这些条形才会慢慢填满。",
    "dash_hello": "你好",
    "dash_reader_sub": "你的个人空间：你的阅读、书签与购买。只有你能看到这些数据。",
    "dash_locked": "你还没有完整书籍",
    "dash_unlock_cta": "10欧元解锁",
    "dash_chapters": "你的章节",
    "dash_bookmarks": "你的书签",
    "dash_my_payments": "你的捐赠与书籍",
    "dash_account": "你的账户",
    "dash_cur_pw": "当前密码（如果有）",
    "dash_new_pw": "新密码",
    "dash_change_pw": "更改密码",
    "dash_pw_ok": "密码已更新！",
    "dash_new_email": "新邮箱",
    "dash_change_email": "更改邮箱",
    "dash_email_ok": "邮箱已更新！",
    "dash_pw_for_email": "请用你的密码确认",
    "dash_empty_reading": "你还没有开始任何章节。夜晚正等着你。",
    "dash_empty_bm": "还没有书签。",
    "dash_empty_pay": "还没有购买或捐赠。",
    "dash_admin_link": "作者看板",
    "ei_kicker": "本书支持者",
    "ei_tagline": "从代码到唱盘，所有相信这个故事的人",
    "ei_p1": "EI SRL — Enterimprese（enterimprese.it）是一家总部位于罗马的软件开发与 B2B 数字服务公司。“有项目？我们倾听，并将其实现”是它的承诺：从电信到数据中心，从应用到网站，再到品牌战略。",
    "ei_p2": "Enterimprese 支持 Una vita da DJ，并让其数字平台得以成形：你正在体验的网站、电影感短视频，以及阅读体验，皆源于这场页面与代码之间的合作。",
    "ei_hq": "总部",
    "ei_vat": "税务信息",
    "ei_web": "网站",
    "ei_svc_tlc": "TLC 机构",
    "ei_svc_cloud": "数据中心与云",
    "ei_svc_app": "APP 开发",
    "ei_svc_web": "网站制作",
    "ei_svc_brand": "品牌策略",
    "ei_svc_seo": "SEO 与网络营销",
    "footer_sponsor": "由……支持",
    "dona_tier_5_title": "DJ的咖啡",
    "dona_tier_5_desc": "用你的专属码立即在线解锁8章。",
    "dona_tier_20_title": "整晚",
    "dona_tier_20_desc": "在线畅读全书 + 1个赠友码。",
    "dona_tier_50_title": "纸质书到家",
    "dona_tier_50_desc": "全部在线内容 + 纸质书寄到你家 + 1个赠友码。",
    "dona_tier_100_title": "收藏版",
    "dona_tier_100_desc": "签名纸质书寄到家 + 2个赠友码 + 你的名字将出现在网站致谢页。",
    "dona_tier_1000_title": "夜晚赞助人",
    "dona_tier_1000_desc": "5本纸质书（自用或赠友）+ 3个赠友码 + 在走向剧院与电影的旅程中获得特别鸣谢。",
    "dona_ship_note": "满50 €，纸质书寄到你家：我们会主动联系你索取收货地址。",
    "b_notify_title": "通知副本",
    "b_notify_sub": "平台发送的每封邮件都会以密件抄送（BCC）到此地址。",
    "b_notify_save": "保存",
    "b_notify_saved": "已保存 ✓",
    "b_co_title": "公司信息",
    "b_co_sub": "财务与公司资料。公开页面仅显示公司名称、国家和增值税号；地址和 SDI 代码仅在此保存。",
    "b_co_name": "公司名称",
    "b_co_country": "国家",
    "b_co_vat": "增值税号",
    "b_co_sdi": "SDI 代码",
    "b_co_addr": "注册地址（不公开）",
    "b_co_web": "网站",
    "b_co_email": "公司邮箱",
    "b_co_ts": "Turnstile 密钥（反机器人）",
    "back_top": "回到顶部",
    "dash_email_pending": "验证码已发送到新邮箱 ✓ — 在确认之前，登录仍使用原邮箱。",
    "dash_email_confirm_hint": "请输入发送到新地址的6位验证码（15分钟内有效）。",
    "dash_email_confirm_btn": "确认更换邮箱"
  }
};
